import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FormControl from '@mui/material/FormControl';
import TextField from "@material-ui/core/TextField";
import swal from 'sweetalert';
import { useAppDispatch, useAppSelector } from '../../useStore'; 
import { Spinners } from '../TableOptions';
import moment from 'moment';
import ModalHeader from '../ModalHeader';
import { reset, sendOffer } from '../../features/Applicant/applicantSlice';



const SendOfferModalComponent = ({ title, nametitle, name, recruiterID, applicationIds }: any) => {

	const dispatch = useAppDispatch();
	const { sendOfferisError, sendOffermessage, sendOfferisLoading, sendOfferisSuccess } = useAppSelector((state: { applicant: any; }) => state.applicant)
	const [welcome, setWelcome] = useState(false);
	const [joiningDate, setJoiningDate] = useState("");
	const [offerDate, setofferDate] = useState("");
	const [application, setapplication] = useState("");
	const [recruiter, setrecruiter] = useState("");
	const handleCloseWelcome = () => setWelcome(false);
	const handleWelcome = () => setWelcome(true);

	const [inputs, setInputs] = useState({
		"offerDate": "",
		"joiningDate": "",
		"comment": "",
		"applicationIds": "",
		"recruiterID": ""
	});


	console.log('name-recruitere',recruiter)



	useEffect(() => {
		if (applicationIds) {
			setapplication(applicationIds)
		}

		if (name[0]?.recruiterID) {
			setrecruiter(name[0]?.recruiterID)
		}

	}, [applicationIds, name[0]?.recruiterID]);

	useEffect(() => {
		setInputs((prevState: any) => {
			return ({
				...prevState,
				applicationIds: applicationIds,
				recruiterID: recruiter
			});
		});
	}, [ applicationIds  ,recruiter]);

    // console.log('recruiter', name[0]?.recruiterID)
	useEffect(() => {
		if (sendOfferisError) {
			swal({
				title: "error",
				text: sendOffermessage,
				icon: "error"
			})
		} else if (sendOfferisSuccess) {
			swal({
				title: "success",
				text: "Send Applicant Offer!",
				icon: "success"
			})
			setWelcome(false)
			setInputs(
				{
					offerDate: " ",
					joiningDate: "",
					comment: "",
					applicationIds: "",
					recruiterID: ""
				}
			)
		}
		dispatch(reset())
	}, [sendOfferisError, sendOfferisSuccess, sendOffermessage, dispatch])


	const handleOnChange = (input: any, value: any) => {

		if (input === 'joiningDate') {
			setJoiningDate(value)
		}
		if (input === 'offerDate') {
			setofferDate(value)
		}
		setInputs((prevState: any) => ({
			...prevState,
			[input]: input === 'joiningDate' || input === 'offerDate' ? moment(value).format('DD/MM/YYYY') : value,
		}));
	};


	const handleSendOffer = () => {
		// @ts-ignore  
		dispatch(sendOffer(inputs));
	}


	return (
		<div>
			<div onClick={handleWelcome} className="more-button">
				{title}
			</div>

			<Modal show={welcome} onHide={handleCloseWelcome}  >
				<ModalHeader setShow={setWelcome} headerTitle={"Send Offer"} />
				<Modal.Body>

					<form onSubmit={handleCloseWelcome}>
						<div className='applicant-name'>
							<h5>Applicant Name</h5>
							{Array.isArray(name) ? name.slice(0, 2)?.map((item) => (
                <p key={item?.id}>{`${item?.title} ${item?.firstName} ${item?.middleName} ${item?.LastName}`}</p>
              )) : null}
              {name?.length > 2 && <p>...</p>}
						</div>
						<div className='schedule-setting mt-3'>
							<FormControl fullWidth>
								<h5>Date Of Offer<span style={{ color: "red" }}> *</span></h5>
								<TextField id="outlined-basic"
									name='date'
									type='date'
									size="small"
									required
									style={{ width: "100%", margin: "10px 0", paddingRight: "10px" }}
									variant="outlined"
									value={offerDate}
									onChange={(e) => handleOnChange("offerDate", e.target.value)} />
							</FormControl>

							<FormControl fullWidth>
								<h5>Joining Date</h5>
								<TextField
									required
									id="outlined-basic"
									name='date'
									type='date'
									size="small"
									style={{ width: "100%", margin: "10px 0" }}
									variant="outlined"
									value={joiningDate}
									onChange={(e) => handleOnChange("joiningDate", e.target.value)} />
							</FormControl>

						</div>

						<div className="comment mt-3">
							<h5>Comment</h5>
							<TextField

								id="outlined-multiline-static"
								multiline
								fullWidth
								type="text"
								minRows={4}
								variant="outlined"
								value={inputs.comment}
								onChange={(e) => handleOnChange("comment", e.target.value)}
							/>
						</div>

					</form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" >
						Cancel
					</Button>
					<Button id="primary" onClick={handleSendOffer}>
						{sendOfferisLoading ? <Spinners size={"sm"} /> : 'Send'}
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

export default SendOfferModalComponent


